var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16663 1.6665H7.49996C3.33329 1.6665 1.66663 3.33317 1.66663 7.49984V12.4998C1.66663 16.6665 3.33329 18.3332 7.49996 18.3332H12.5C16.6666 18.3332 18.3333 16.6665 18.3333 12.4998V10.8332",
    stroke: "url(#paint0_linear_200_1549)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3671 2.51541L6.80039 9.08208C6.55039 9.33208 6.30039 9.82375 6.25039 10.1821L5.89205 12.6904C5.75872 13.5987 6.40039 14.2321 7.30872 14.1071L9.81705 13.7487C10.1671 13.6987 10.6587 13.4487 10.9171 13.1987L17.4837 6.63208C18.6171 5.49875 19.1504 4.18208 17.4837 2.51541C15.8171 0.848746 14.5004 1.38208 13.3671 2.51541Z",
    stroke: "url(#paint1_linear_200_1549)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4252 3.45898C12.9835 5.45065 14.5418 7.00898 16.5418 7.57565",
    stroke: "url(#paint2_linear_200_1549)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_200_1549",
    x1: -2.31065,
    y1: -1.59003,
    x2: 19.4594,
    y2: 1.19403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5D01C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#826320"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_200_1549",
    x1: 2.85133,
    y1: -1.01893,
    x2: 19.399,
    y2: 1.09757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5D01C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#826320"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_200_1549",
    x1: 11.4428,
    y1: 2.65462,
    x2: 16.82,
    y2: 3.34228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5D01C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#826320"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.ad83c96b4d2a191585db1eb66f4bb70f.svg";
export { ForwardRef as ReactComponent };